import { useLang } from "@/App";

const Marquee = () => {
  const { t } = useLang();
  const content = t.marquee.repeat(3);
  return (
    <div data-testid="editorial-marquee" className="relative w-full overflow-hidden py-8 md:py-10 border-y border-line bg-paper">
      <div className="flex animate-marquee w-max">
        {[0, 1].map((i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="font-display italic text-3xl md:text-5xl text-ink/25 mx-4 whitespace-nowrap">{content}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
